window.jQuery = window.$ = require('jquery');

$(document).ready(function () {

    var $productDetail = $('.js-product-detail');
    var $imageWrapper = $productDetail.find('.magnified-image-wrapper');

    /* open magnified image */
    $(document).on('click', '.carousel-item-list .carousel-item.slick-current:not(.video-item)' , function () {
        if($(this).closest($productDetail).length) {
            var targetIndex = $(this).data('slick-index');
            $('.slider-section-sticky').css('z-index', 120);
            if( $(window).width() > 767  ) {
                $imageWrapper.addClass('d-block').find('[data-slide-to="' + targetIndex + '"]').addClass('d-block').closest('li').addClass('active');
            } 
        }
    });

    /* on mouse move on magnified image */
    $(document).on('mousemove', '.magnified-image-wrapper', function (e) {
        if( $(window).width() > 767 ){
            var moveX = ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '%';
            var moveY = ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%';
            $(this).find('.magnified-image').css({'background-position': moveX + ' ' + moveY });
        }
    });

    /* on closing the magnifying window */
    $(document).on('click', '.magnified-image-wrapper .btn-close', function () {
        $('.magnified-image-wrapper').removeClass('d-block').find('div.d-block').removeClass('d-block');
        $(this).closest('ul').find('li').removeClass('active');
        $('.slider-section-sticky').removeAttr('style');
    });

    /* show respective image on overlay thumbnail click */
    $(document).on('click', '.overlay-thumbnail li:not(.btn-close)', function () {
        var targetElement = $(this).find('img').data('slide-to');
        $('.magnified-image').removeClass('d-block');
        $(this).closest('ul').find('li').removeClass('active');        
        $(this).addClass('active');
        $('.magnified-image-wrapper').find('[data-slide-to="' + targetElement + '"]').addClass('d-block');
    });

    /* play video if clicked on video thumbnail and pause if slider changes to another */
    $('.carousel-item-list').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if($('.carousel-item[data-slick-index="' + currentSlide + '"]').hasClass('video-item')){
            var video = $(this).find('.carousel-item.video-item[data-slick-index="' + currentSlide + '"] video').get(0);
            video.pause();
        }
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        if($('.carousel-item[data-slick-index="' + currentSlide + '"]').hasClass('video-item')){
            var video = $(this).find('.carousel-item.video-item[data-slick-index="' + currentSlide + '"] video').get(0);
            video.play();
            video.muted = true;
        }
    });
    
    /* toggle play and pause on clicking video  */
    $(document).on('click', "video", function(event) {
        var video = $(this).get(0);
        if (video.paused) {
            video.currentTime = 0;
            video.play();
            video.muted = true;
        } else {
            video.pause();
        }
    });

    /* pinch zoom functionality - mobile view */  
    var mobilePopUpWindow;
    var mobilePopUpWindowImgContainer;
    var popSlideContainer;
    var buttonLeftNav;
    var buttonRightNav;
    var zoomTarget;
    var totalZoomImages;
    var zoomImageContainerWidth;

    $(document).on('click', '.carousel-item-list .carousel-item.slick-current:not(.video-item)' , function () {
        if( ($(window).width() < 767 ) && $(this).closest($productDetail).length) {
            totalZoomImages = $('.zoom').length;
            mobilePopUpWindow = $('.fullScreenImageGalleryMobile');
            mobilePopUpWindowImgContainer = mobilePopUpWindow.find('.zoom');
            popSlideContainer = mobilePopUpWindow.find('.zoomedImagesMobile');
            buttonLeftNav = $('.fullScreenImageGalleryMobile .fa-circle-left');
            buttonRightNav = $('.fullScreenImageGalleryMobile .fa-circle-right');
            zoomTarget = $('.zoom img');
            windowWidth = $(window).width();
            windowHeight = $(window).height();
            zoomImageContainerWidth = windowWidth * totalZoomImages;
            marginValue = 0;
            mobilePopUpWindow.show();
            $('html').addClass('zoom-gallery-open-mobile');
            popSlideContainer.css('width', zoomImageContainerWidth);
            mobilePopUpWindowImgContainer.css({
                width: windowWidth,
                'min-width': windowWidth,
                height: '100%',
                'min-height': windowHeight,
            });
            var largeGalleryImageActiveMobile = $(this).data('slide-to'); 
            mobilePopUpWindow.find('img[data-slide-to="' + largeGalleryImageActiveMobile + '"]').closest('.zoom').addClass('active');
            marginValue = -(windowWidth * largeGalleryImageActiveMobile);

            if( largeGalleryImageActiveMobile == 0 ) {
                buttonLeftNav.attr('disabled')
            } 
            if ( largeGalleryImageActiveMobile == (totalZoomImages - 1 ) ) {
                buttonRightNav.attr('disabled')
            }

            popSlideContainer.css('margin-left', marginValue);        
            Array.from(zoomTarget).forEach((el) => {
                new PinchZoom.default(el, {
                    tapZoomFactor: 2,
                    zoomOutFactor: 1.3,
                    animationDuration: 300,
                    maxZoom: 4,
                    minZoom: 0.5,
                    draggableUnzoomed: !1,
                    lockDragAxis: !1,
                    setOffsetsOnce: !1,
                    use2d: !0,
                    zoomStartEventName: 'pz_zoomstart',
                    zoomUpdateEventName: 'pz_zoomupdate',
                    zoomEndEventName: 'pz_zoomend',
                    dragStartEventName: 'pz_dragstart',
                    dragUpdateEventName: 'pz_dragupdate',
                    dragEndEventName: 'pz_dragend',
                    doubleTapEventName: 'pz_doubletap',
                    verticalPadding: 0,
                    horizontalPadding: 0,
                    onZoomStart: null,
                    onZoomEnd: null,
                    onZoomUpdate: null,
                    onDragStart: null,
                    onDragEnd: null,
                    onDragUpdate: null,
                    onDoubleTap: null,
                });
            });
        }
    });

    /* close pinch zoom container */
    $(document).on('click', '.fullScreenImageGalleryMobile .fa-close', function() {
        mobilePopUpWindow.hide();
        mobilePopUpWindowImgContainer.removeClass('active');
        $('html').removeClass('zoom-gallery-open-mobile');
        $('.zoom img').each(function () {
            $(this).removeAttr('style');
            $(this).closest('.zoom').prepend(this);
        });
        $('.pinch-zoom-container').remove();
        $('.slider-section-sticky').removeAttr('style');
    });

    /* slide to next image in pinch zoom view - mobile */
    $(document).on('click', '.fullScreenImageGalleryMobile .fa-circle-right', function(event) {
        var currentActive = $('.fullScreenImageGalleryMobile').find('.zoom.active img').data('slide-to');
        if (currentActive != (totalZoomImages - 1)) {
            buttonLeftNav.removeAttr('disabled')
            mobilePopUpWindowImgContainer.removeClass('active');
            $('img[data-slide-to="' + (currentActive) + '"]').closest('.zoom').removeClass('active').nextAll('.zoom:not(.video-item)').filter(':first').addClass('active');
            marginValue += -windowWidth;
            popSlideContainer.animate({
                'margin-left': marginValue,
            }, 500);
        }
        if (currentActive === (totalZoomImages - 2)) {
            $(event.target).attr('disabled')
        }
    });

    /* slide to previous image in pinch zoom view - mobile */
    $(document).on('click', '.fullScreenImageGalleryMobile .fa-circle-left', function(event) {
        var currentActive = $('.fullScreenImageGalleryMobile').find('.zoom.active img').data('slide-to');
        if (currentActive > 0) {
            buttonRightNav.removeAttr('disabled')
            mobilePopUpWindowImgContainer.removeClass('active');
            $('img[data-slide-to="' + (currentActive) + '"]').closest('.zoom').removeClass('active').prevAll('.zoom:not(.video-item)').filter(':first').addClass('active');
            marginValue += windowWidth;
            popSlideContainer.animate({
                'margin-left': marginValue,
            }, 500);
        }
        if (currentActive === 1) {
            $(event.target).attr('disabled', true)
        }
    });
});